import React, { FC, Suspense } from "react";
import { connect } from "react-redux";
import { Outlet, useMatch } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { useBranding } from "../../../branding/BrandingProvider";
import LoadingPage from "../../../components/LoadingPage/LoadingPage";
import { authSelectAuthenticated } from "../../../reduxFolder/selectors/globalSelectors";
import { isAnonymousSession } from "../../../utils/authData";
import { lazyWithRetry } from "../../../utils/lazyWithRetry";

const Landing = lazyWithRetry(() => import("../../Landing/Landing"));

interface LandingGateProps {
  authenticated: boolean | null;
}

// Wraps the authorized route group. Exactly "/" + an anonymous session + a
// partner with publicRoot "landing" → the marketing landing, outside Layout.
// Everything else falls through to AuthorizedRoute, so deep links keep
// redirecting to /signin and a token still being validated keeps its loader.
export const LandingGate: FC<LandingGateProps> = ({ authenticated }) => {
  const { publicRoot } = useBranding();
  const isRoot = useMatch({ path: "/", end: true }) !== null;

  if (
    publicRoot !== "landing" ||
    !isRoot ||
    !isAnonymousSession(authenticated)
  ) {
    return <Outlet />;
  }

  return (
    <Suspense fallback={<LoadingPage />}>
      <Landing />
    </Suspense>
  );
};

export default connect(
  createStructuredSelector({ authenticated: authSelectAuthenticated }),
)(LandingGate);
